import React, { useRef } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import ReCAPTCHA from "react-google-recaptcha";
import Swal from "sweetalert2";

import { fetch } from "../../utils/fetch";
import { RECAPTCHA } from "../../utils/constants";
import { useToggle } from "../../hooks/useToggle";
import { PoliticaProteccionComponent } from "../../components/footer/politica-proteccion";

const validationSchema = Yup.object().shape({
  nombre: Yup.string().required("Campo obligatorio"),
  apellido: Yup.string().required("Campo obligatorio"),
  email: Yup.string().email("Email inválido").required("Campo obligatorio"),
  telefono: Yup.string().required("Campo obligatorio"),
  comentario: Yup.string().required("Campo obligatorio"),
  aceptoPrivacidad: Yup.boolean().oneOf([true], "Campo obligatorio"),
});

const Contacto = () => {
  const captcha = useRef(null);
  const politicaToggle = useToggle();

  const initialValues = {
    nombre: "",
    apellido: "",
    email: "",
    telefono: "",
    comentario: "",
    aceptoPrivacidad: false,
  };

  const onSubmit = async (values, resetForm) => {
    // Ajustado al modelo solicitado: validar captcha dentro del if y usar else para mensaje de robot.
    if (captcha.current?.getValue()) {
      const correo = {
        to: "privilegehb@hbritanico.com.ar", // Ajustar si se requiere múltiples destinatarios
        subject: "Solicitud de contacto - Privilege HB",
        text: `<b>Nombre</b> ${values.nombre} <br/>
        <b>Apellido</b> ${values.apellido} <br/>
        <b>Email</b> ${values.email} <br/>
        <b>Teléfono</b> ${values.telefono} <br/>
        <b>Comentario</b> ${values.comentario} <br/>
        `,
      };

      await fetch(`email`, "post", correo);

      resetForm();
      captcha.current?.reset();
      Swal.fire("Info!", "Solicitud de contacto enviada con éxito", "info");
    } else {
      Swal.fire("Info!", "Debe indicar que no es un robot", "info");
    }
  };

  return (
    <div className="card p-4 b-radius-10">
      <h2 style={{ color: "#05294F" }}><strong>Contacto</strong></h2>
      <hr />
      <div className="row" id="privilege-contact-container">
        <div className="col-12 col-lg-8">
          <div style={{ marginBottom: 35 }}>
            <p><strong>Ubicación</strong>: Perdriel 74</p>
            <p><strong>Horarios</strong>: Lunes a viernes de 08:00 a 20:00 hs.</p>
            <p><strong>Mail</strong>: privilegeHB@hbritanico.com.ar </p>
            <p><strong>Teléfono</strong>: (+54) 4309-6899</p>
            <p><strong>Chat institucional</strong>: 11-3015-9749 opción 7</p>
            <hr className="d-block d-lg-none my-4" />
          </div>
          <h3 style={{ color: "#05294F", marginBottom: 40 }}><strong>Dejanos tu consulta</strong></h3>

      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={(values, { resetForm }) => onSubmit(values, resetForm)}
      >
        {({ values, errors, handleChange, handleSubmit }) => (
          <form className="section_contacto_form" onSubmit={handleSubmit}>
            <div className="mb-3 row align-items-center">
              <div className="col-lg-2">
                <label>Nombre</label>
              </div>
              <div className="col-lg-10">
                <input
                  type="text"
                  name="nombre"
                  value={values.nombre}
                  onChange={handleChange}
                  className="form-control b-radius-20 shadow-blue"
                />
                <div className="text-danger text-danger-custom">{errors?.nombre}</div>
              </div>
            </div>

            <div className="mb-3 row align-items-center">
              <div className="col-lg-2">
                <label>Apellido</label>
              </div>
              <div className="col-lg-10">
                <input
                  type="text"
                  name="apellido"
                  value={values.apellido}
                  onChange={handleChange}
                  className="form-control b-radius-20 shadow-blue"
                />
                <div className="text-danger text-danger-custom">{errors?.apellido}</div>
              </div>
            </div>

            <div className="mb-3 row align-items-center">
              <div className="col-lg-2">
                <label>Email</label>
              </div>
              <div className="col-lg-10">
                <input
                  type="email"
                  name="email"
                  value={values.email}
                  onChange={handleChange}
                  className="form-control b-radius-20 shadow-blue"
                />
                <div className="text-danger text-danger-custom">{errors?.email}</div>
              </div>
            </div>

            <div className="mb-3 row align-items-center">
              <div className="col-lg-2">
                <label>Teléfono</label>
              </div>
              <div className="col-lg-10">
                <input
                  type="text"
                  name="telefono"
                  value={values.telefono}
                  onChange={handleChange}
                  className="form-control b-radius-20 shadow-blue"
                />
                <div className="text-danger text-danger-custom">{errors?.telefono}</div>
              </div>
            </div>

            <div className="mb-3 row align-items-center">
              <div className="col-lg-12">
                <label className="mb-2">Por favor, escriba su comentario</label>
                <textarea
                  name="comentario"
                  value={values.comentario}
                  onChange={handleChange}
                  className="form-control b-radius-20 shadow-blue"
                  rows="4"
                />
                <div className="text-danger text-danger-custom">{errors?.comentario}</div>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-12">
                <div className="mb-2 form-check">
                  <input
                    name="aceptoPrivacidad"
                    checked={values.aceptoPrivacidad}
                    onChange={handleChange}
                    className="form-check-input"
                    type="checkbox"
                    id="privCheck"
                  />
                  <label className="form-check-label" htmlFor="privCheck">
                    Acepto la {" "}
                    <button
                      type="button"
                      className="btn btn-link p-0 align-baseline"
                      onClick={politicaToggle.onToggle}
                    >
                      política de privacidad
                    </button>{" "}
                    del Hospital Británico
                  </label>
                  <div className="text-danger">{errors?.aceptoPrivacidad}</div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-12">
                <div id="botCaptcha">
                  <ReCAPTCHA ref={captcha} sitekey={RECAPTCHA} />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-12">
                <div className="mt-6 mb-2">
                  <button type="submit" className="btn grandiend-btn b-radius-20 px-5">
                    Enviar
                  </button>
                </div>
              </div>
            </div>
          </form>
        )}
      </Formik>

          <PoliticaProteccionComponent
            visible={politicaToggle.toggle}
            onToggle={politicaToggle.onToggle}
          />
          {/* FIN POLITICA DE PRIVACIDAD */}
        </div>
      </div>
    </div>
  );
};

export default Contacto;